import axios, { axiosPrivate } from "../api/axios";
import {
  LOGIN_API,
  LOGOUT_API,
  REFRESH_API,
  REGISTER_API,
  REQUEST_PASSWORD_RESET_API,
  RESET_PASSWORD_API,
  VERIFY_EMAIL_API,
} from "./endpoints";

export const loginAPI = (email, password) => {
  return axiosPrivate.post(
    LOGIN_API,
    JSON.stringify({ email, password })
  );
};

export const refreshTokenAPI = () => {
  return axiosPrivate.post(
    REFRESH_API,
    {},
  );
};

export const logoutAPI = () => {
  return axiosPrivate.post(LOGOUT_API);
};

export const registerAPI = (data) => {
  const userData = {
    first_name: data.firstName,
    last_name: data.lastName,
    email: data.email,
    password1: data.password1,
    password2: data.password1,

    name: data.schoolName,
    phone: data.phone,
    capacity: data.capacity,
    countries: data.countries,
    programType: data.programType,
 
    // Anti-spam fields 
    captcha_token: data.captcha_token,
    confirm_email_hidden: data.confirm_email_hidden,
  }

  return axiosPrivate.post(REGISTER_API, JSON.stringify(userData));
};

export const verifyEmailAPI = (uid, token) => {
  return axios.get(`${VERIFY_EMAIL_API}/${uid}/${token}`);
};

export const requestPasswordResetAPI = (email) => {
  return axios.post(REQUEST_PASSWORD_RESET_API, { email });
};

export const resetPasswordAPI = (uid, token, password) => {
  return axios.post(RESET_PASSWORD_API, {
    uid: uid,
    token: token,
    password: password,
  });
};
